import { z } from 'zod';

export const CandidateReputationClarificationSchema = z.object({
  submissionComments: z.string(),
  id: z.string().uuid().nullish(),
});

export type CandidateReputationClarification = z.infer<
  typeof CandidateReputationClarificationSchema
>;
